export default __webpack_public_path__ + "static/media/icon-2-active.d94902e0.svg";